import { api_configuration } from "../../common";
import csr = api_configuration.types.client_state.alan_api;
import datastore_interface_read_api = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_reply.alan_api;
import api_gui_model = api_configuration.libraries.gui_definition_lib.types.gui_model.alan_api;
import * as update from "../widgets/instructions/update";
import { iState } from "../state/Stategroup";
import { iCollection } from "../state/Collection";
import * as Entry from "../state/Entry";

export default function initializeNewNodeFromSubscriptionResult(
	node: csr.Cnode,
	duplication_mapping: api_gui_model.Cduplication_node_mapping,
	subscription_result_data: datastore_interface_read_api.Csubscription_result_data
): void {
	subscription_result_data.properties.read_permitted.switch({
		no: undefined,
		yes: (readable) => {
			duplication_mapping.properties.properties.forEach(function (property) {
				const property_name = property.key.entry;
				property.properties.type.switch({
					number: function () {
						const number_stage = node.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("number");
						const value = readable.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("number").properties.value.value;
						update.number(number_stage, value, "user");
					},
					text: function () {
						const text_stage = node.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("text");
						const value = readable.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("text").properties.value;
						const mutable_text = text_stage;
						mutable_text.properties.is_editable.set("yes", {
							modified: [
								"yes",
								{
									value: value,
									saving: ["no", {}],
								},
							],
							"edit mode": ["off", {}],
						});
						mutable_text.properties.is_set.set("yes", {
							text: value,
							by: ["user", {}],
						});
					},
					file: function () {
						const file_stage = node.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("file");
						const file_mutable = file_stage;
						const file_value = readable.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("file");
						file_mutable.properties.is_set.set("yes", {
							token: file_value.properties.token,
							extension: file_value.properties.extension,
						});
						file_mutable.properties.is_valid.set("yes", {});
					},
					group: function (group_type) {
						const group_stage = node.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("group");
						const group_node = readable.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("group");
						initializeNewNodeFromSubscriptionResult(
							group_stage.properties.node,
							group_type.properties.mapping,
							group_node.properties.node_data
						);
					},
					"state group": function (state_group_type) {
						const state_group_stage = node.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("state group");
						const state_group_data = readable.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("state group");
						const state_name = state_group_data.properties.state.entry;
						const state = state_group_stage.properties.states.get(state_group_data.properties.state.entry)!;
						iState(state).__select("user");
						initializeNewNodeFromSubscriptionResult(
							state.properties.node,
							state_group_type.properties.states.get(state_name)!.properties.mapping,
							state_group_data.properties.node_data
						);
					},
					collection: function (collection_type) {
						const gui_collection = collection_type.inferences.collection();

						const collection_value = readable.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("collection");
						const collection = node.properties.attributes
							.get(property_name)!
							.properties.type.cast("property")
							.properties.type.cast("collection");

						switch (collection_value.properties.result.state.name) {
							case "update":
								break;
							case "entries": {
								const entries_result = collection_value.properties.result.state.node;
								for (const [key, entry] of entries_result.properties.entries) {
									const entry_new_node = iCollection(collection).__addEntry("user", key);
									switch (gui_collection.properties.duplication_mapping.state.name) {
										case "from current context": {
											const from_current_context_duplication_mapping =
												gui_collection.properties.duplication_mapping.state.node;
											initializeNewNodeFromSubscriptionResult(
												entry_new_node.properties.node,
												from_current_context_duplication_mapping.properties.mapping,
												entry.properties.node_data
											);
											break;
										}
										case "none": {
											break;
										}
									}
									Entry.keyInitialized(entry_new_node);
								}
								for (const graph of iCollection(collection).graphs) {
									graph.reset(false);
								}
								break;
							}
						}
					},
				});
			});
		},
	});
}
